import styled from "@emotion/styled";
import React, { PropsWithChildren } from "react";

import { Link } from "@brexhq/next/src/components/shared/Link";

import { TransformedCarouselCardProps } from "../types";

const CardContainer = styled.div<{
  cardWidth: TransformedCarouselCardProps["cardWidth"];
}>(({ theme, cardWidth }) => {
  return {
    display: "flex",
    height: "100%",
    scrollSnapAlign: "start",
    width: cardWidth?.LRG,
    [theme.breakpoints.LRG]: {
      scrollMarginLeft: `${theme.grid.wrapperOuterMargin.LRG}px`,
    },
    [`@media(min-width: ${theme.maxWidths.moduleGrid})`]: {
      scrollMarginLeft: `calc(((100vw - ${theme.maxWidths.moduleGrid}) * .5 ) + ${theme.grid.wrapperOuterMargin.LRG}px)`,
    },
    [theme.breakpoints.MED]: {
      scrollMarginLeft: `${theme.grid.wrapperOuterMargin.MED}px`,
    },
    [theme.breakpoints.SML]: {
      scrollMarginLeft: `${theme.grid.wrapperOuterMargin.SML}px`,
      width: cardWidth?.SML,
    },
  };
});

/**
 *
 * this wrapper sets a width for the cards in the carousel and gives each one a scroll margin so it aligns to the buttons
 */
export const CarouselCardController: React.FC<
  PropsWithChildren<TransformedCarouselCardProps>
> = ({ children, cardUrl, id: index, cardWidth }) => {
  return (
    <CardContainer cardWidth={cardWidth}>
      {cardUrl ? (
        <Link
          modifier="unstyled"
          component="carousel"
          section={`${index}`}
          to={cardUrl}
          label=""
        >
          {children}
        </Link>
      ) : (
        children
      )}
    </CardContainer>
  );
};
